import WinlosesTypes from './types';
import { OnnaWinlosesState, OnnaWinlosesDispatchAction } from './state';
import { Reducer } from 'redux';

const initialState: OnnaWinlosesState = {
    wins: '',
    loses: '',
    avg: '',
    touch : 0,
    perfect : 0,
    chefmet: 0,
}

export const WinlosesReducer : Reducer<OnnaWinlosesState, OnnaWinlosesDispatchAction>= 
    (state = initialState, action) => {
        switch(action.type) {
            case WinlosesTypes.FETCH_START:
                return state
            case WinlosesTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default WinlosesReducer;